module.exports = __webpack_public_path__ + "4ec8a070b10eee71c0d5d4ceef5b3c1f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/17_E3.mp3
// module id = 116
// module chunks = 0